<template>
  <div class="twoqbsxml-card">
    <div class="twoqbsxml-card-top">
      <div class="twoqbsxml-card-local">{{ item.local_number }}</div>
      <div class="twoqbsxml-card-status-text">
        <span class="twoqbsxml-status-promo" v-if="item.promotion == 1 && isPromotionActive(item) && item.status_name == 'Dostępne'">
          Promocja
        </span>
        <span v-else-if="item.status_name == 'Dostępne'">
          Dostępne
        </span>
        <span class="twoqbsxml-status-reserved" v-else-if="
          item.status_name == 'Rezerwacja ustna' ||
          item.status_name == 'Umowa rezerwacyjna'
        ">
          Rezerwacja
        </span>
        <span v-else-if="
          item.status_name == 'Umowa końcowa' ||
          item.status_name == 'Umowa deweloperska' ||
          item.status_name == 'Umowa przedwstępna'
        ">
          Sprzedany
        </span>
        <span v-else>{{ item.status_name }}</span>
      </div>
    </div>

    <div class="twoqbsxml-card-preview">
      <a v-if="getPlanImageSrc(item) && isResidentialType" :href="planHref" target="_blank" rel="noopener">
        <img :src="getPlanImageSrc(item)" :alt="'Rzut ' + item.local_number" />
      </a>
      <img v-else-if="getPlanImageSrc(item) && !isResidentialType" :src="getPlanImageSrc(item)" :alt="'Rzut ' + item.local_number" />
      <div v-else-if="investmentLogoUrl" class="twoqbsxml-card-preview-logo">
        <img :src="investmentLogoUrl" :alt="pluginSettings?.investment_name || 'Logo inwestycji'" />
      </div>
      <div v-else class="twoqbsxml-card-preview-placeholder">Brak podgladu</div>
    </div>

    <div class="twoqbsxml-card-separator"></div>

    <div class="twoqbsxml-card-stats">
      <div class="twoqbsxml-card-stats-left">
        <div class="twoqbsxml-card-stats-label">{{ item.type }}:</div>
        <div class="twoqbsxml-card-stats-area">
          <span v-if="(item.area && item.area > 0) || (item.area_usable && item.area_usable > 0)">
            {{ item.area && item.area > 0 ? item.area : item.area_usable }} m<sup>2</sup>
          </span>
        </div>
      </div>
      <div class="twoqbsxml-card-stats-right" v-if="item.rooms && item.rooms > 0">
        <div class="twoqbsxml-card-stats-rooms">{{ item.rooms }}</div>
        <div class="twoqbsxml-card-stats-rooms-label">
          <span v-if="item.rooms == 1">Pokój</span>
          <span v-else-if="item.rooms >= 2 && item.rooms <= 4">Pokoje</span>
          <span v-else>Pokoi</span>
        </div>
      </div>
    </div>

    <div class="twoqbsxml-card-separator"></div>

    <div v-if="hasExtras" class="twoqbsxml-card-extras">
      <div v-if="hasGarden" class="twoqbsxml-card-extra-item">
        <img class="twoqbsxml-extra-icon" :src="require('@/assets/ogrod.png')" alt="" aria-hidden="true" />
        <span v-html="getFeatureHtml('Ogród', item.ogrod)"></span>
      </div>
      <div v-if="hasLoggia" class="twoqbsxml-card-extra-item">
        <img class="twoqbsxml-extra-icon" :src="require('@/assets/loggia.png')" alt="" aria-hidden="true" />
        <span v-html="getFeatureHtml('Loggia', item.loggia)"></span>
      </div>
      <div v-if="hasBalcony" class="twoqbsxml-card-extra-item">
        <img class="twoqbsxml-extra-icon" :src="require('@/assets/balkon.png')" alt="" aria-hidden="true" />
        <span v-html="getFeatureHtml('Balkon', item.balkon ?? item.balcony)"></span>
      </div>
      <div v-if="hasTerrace" class="twoqbsxml-card-extra-item">
        <img class="twoqbsxml-extra-icon" :src="require('@/assets/taras.png')" alt="" aria-hidden="true" />
        <span v-html="getFeatureHtml('Taras', item.taras ?? item.terrace)"></span>
      </div>
      <div v-if="hasMandatoryParkingSpaces(item)" class="twoqbsxml-card-extra-item">
        <svg class="twoqbsxml-extra-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M13 3H6v18h4v-6h3c3.31 0 6-2.69 6-6s-2.69-6-6-6zm.2 8H10V7h3.2c1.1 0 2 .9 2 2s-.9 2-2 2z"/>
        </svg>
        <span>{{ getMandatoryParkingSpacesValue(item) }} m. postojowe</span>
      </div>
    </div>

    <div class="twoqbsxml-card-bottom">
      <div v-if="hasPromotionOldPrice(item)" class="twoqbsxml-card-price-old">
        {{ numberWithSpaces(item.price) }} zł
      </div>

      <div v-if="getDisplayPrice(item) !== null" class="twoqbsxml-card-price-main">
        <span>{{ numberWithSpaces(getDisplayPrice(item)) }} zł</span>
        <span
          v-if="shouldShowPriceInfo(item)"
          class="twoqbsxml-price-info-wrap"
          @mouseenter="loadPriceHistoryInfo(item)"
          @focusin="loadPriceHistoryInfo(item)"
        >
          <button
            type="button"
            class="twoqbsxml-price-info-trigger"
            :aria-label="'Informacja o cenie lokalu ' + (item.local_number || '')"
          >
            i
          </button>
          <span class="twoqbsxml-price-info-tooltip">{{ getPriceInfoTooltipText(item) }}</span>
        </span>
      </div>

      <div v-if="getDisplayPriceMkw(item) !== null" class="twoqbsxml-card-price-mkw">
        {{ numberWithSpaces(getDisplayPriceMkw(item)) }} zł/m<sup>2</sup>
      </div>

      <a
        v-if="isResidentialType"
        :href="flatUrl"
        @click="$emit('save-filters-state')"
        class="twoqbsxml-card-more"
      >
        Dowiedz się więcej
      </a>
      <button
        v-else
        type="button"
        class="twoqbsxml-card-more"
        @click="$emit('open-reservation-modal', item.local_number)"
      >
        Zarezerwuj
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "ListingCard",
  props: {
    item: {
      type: Object,
      required: true
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    planHref: {
      type: String,
      required: true
    },
    flatUrl: {
      type: String,
      required: true
    },
    pluginSettings: {
      type: Object,
      default: () => ({})
    },
    investmentLogoUrl: {
      type: String,
      default: ""
    },
    isPromotionActive: {
      type: Function,
      required: true
    },
    hasMandatoryParkingSpaces: {
      type: Function,
      required: true
    },
    getMandatoryParkingSpacesValue: {
      type: Function,
      required: true
    },
    hasPromotionOldPrice: {
      type: Function,
      required: true
    },
    getDisplayPrice: {
      type: Function,
      required: true
    },
    getDisplayPriceMkw: {
      type: Function,
      required: true
    },
    numberWithSpaces: {
      type: Function,
      required: true
    },
    shouldShowPriceInfo: {
      type: Function,
      required: true
    },
    loadPriceHistoryInfo: {
      type: Function,
      required: true
    },
    getPriceInfoTooltipText: {
      type: Function,
      required: true
    },
    getPlanImageSrc: {
      type: Function,
      required: true
    }
  },
  computed: {
    isResidentialType() {
      const type = String(this.item?.type || '').trim().toLowerCase();
      return type === 'mieszkanie' || type === 'dom';
    },
    hasGarden() {
      const value = String(this.item?.ogrod ?? '').trim();
      return value !== '' && value !== '0';
    },
    hasBalcony() {
      const value = String(this.item?.balkon ?? this.item?.balcony ?? '').trim();
      return value !== '' && value !== '0';
    },
    hasLoggia() {
      const value = String(this.item?.loggia ?? '').trim();
      return value !== '' && value !== '0';
    },
    hasTerrace() {
      const value = String(this.item?.taras ?? this.item?.terrace ?? '').trim();
      return value !== '' && value !== '0';
    },
    hasAnyFeatures() {
      return Boolean(
        this.item?.rooms?.length
        || this.hasGarden
        || this.hasBalcony
        || this.hasLoggia
        || this.hasTerrace
        || this.hasMandatoryParkingSpaces(this.item)
      );
    },
    hasExtras() {
      return this.hasGarden || this.hasBalcony || this.hasLoggia || this.hasTerrace || this.hasMandatoryParkingSpaces(this.item);
    }
  },
  methods: {
    getFeatureText(label, rawValue) {
      const value = String(rawValue ?? '').trim();
      if (!value || value === '0') return label;
      const normalized = value.replace(',', '.');
      const numericValue = Number(normalized);
      if (Number.isFinite(numericValue) && numericValue > 0) {
        return `${label} ${value} m2`;
      }
      return label;
    },
    getFeatureHtml(label, rawValue) {
      const value = String(rawValue ?? '').trim();
      if (!value || value === '0') return label;
      const normalized = value.replace(',', '.');
      const numericValue = Number(normalized);
      if (Number.isFinite(numericValue) && numericValue > 0) {
        return `${label}: ${value} m<sup>2</sup>`;
      }
      return label;
    }
  }
};
</script>
